import { render, staticRenderFns } from "./class_record_detail_list.vue?vue&type=template&id=f8adbb68&scoped=true"
import script from "./class_record_detail_list.vue?vue&type=script&lang=js"
export * from "./class_record_detail_list.vue?vue&type=script&lang=js"
import style0 from "./class_record_detail_list.vue?vue&type=style&index=0&id=f8adbb68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8adbb68",
  null
  
)

export default component.exports